import PartnerWggLogo from './PartnerWggLogo';

export default PartnerWggLogo;
